"use client";

import { Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { setTheme, useTheme } from "@/lib/client/theme";

/** Round header control flipping <html class="dark">. */
export function ThemeToggle() {
  const t = useTranslations("Flow.header");
  const theme = useTheme();

  return (
    <button
      type="button"
      aria-label={t("toggleTheme")}
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="flex h-8 w-8 items-center justify-center rounded-full border border-input text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
    >
      {theme === "dark" ? (
        <Moon className="h-[15px] w-[15px]" />
      ) : (
        <Sun className="h-[15px] w-[15px]" />
      )}
    </button>
  );
}
